"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTypes = void 0;
var PriceTypes;
(function (PriceTypes) {
    PriceTypes["WHOLESALE"] = "wholesale";
    PriceTypes["FINAL"] = "final";
    PriceTypes["RETAIL"] = "retail";
})(PriceTypes = exports.PriceTypes || (exports.PriceTypes = {}));
